'use client';

import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FinalCTA from '../_shared/sections/FinalCTA';

type Props = { lang: Locale };

const DiscoverBcFinalCTA = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  return (
    <FinalCTA
      accent="#A78BFA"
      ariaLabel={t('DiscoverBc/FinalCTA/aria_label')}
      copy={{
        headlineA: t('DiscoverBc/FinalCTA/title1'),
        headlineB: t('DiscoverBc/FinalCTA/title2'),
        subhead: t('DiscoverBc/FinalCTA/subtitle'),
        ctaPrimary: {
          label: t('DiscoverBc/FinalCTA/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('DiscoverBc/FinalCTA/cta_secondary'),
          href: `/${lang}/business-cards`,
        },
      }}
    />
  );
};

export default DiscoverBcFinalCTA;
